import type { ComponentType } from "react";
import { TitleSlide } from "./TitleSlide";
import { SectionDividerSlide } from "./SectionDividerSlide";
import { AgendaSlide } from "./AgendaSlide";
import { TeamSlide } from "./TeamSlide";
import { ContentSlide } from "./ContentSlide";
import { FlowSlide } from "./FlowSlide";
import { ArchitectureSlide } from "./ArchitectureSlide";
import { ComparisonSlide } from "./ComparisonSlide";
import { ImageGridSlide } from "./ImageGridSlide";
import { DemoTransitionSlide } from "./DemoTransitionSlide";
import { DiscussionSlide } from "./DiscussionSlide";
import { ComingSoonSlide } from "./ComingSoonSlide";
import { ThankYouSlide } from "./ThankYouSlide";
import { GanttSlide } from "./GanttSlide";
import { VModelSlide } from "./VModelSlide";
import { TemplatesSnapshotsSlide } from "./TemplatesSnapshotsSlide";
import { BehavioralParitySlide } from "./BehavioralParitySlide";
import { HostOSSlide } from "./HostOSSlide";
import { ArmArchitectureSlide } from "./ArmArchitectureSlide";
import { POCProposalSlide } from "./POCProposalSlide";
import { QuestionsAnsweredSlide } from "./QuestionsAnsweredSlide";
import { SoftwareFactorySlide } from "./SoftwareFactorySlide";
import { AuthenticationSlide } from "./AuthenticationSlide";
import { SecureAdbSlide } from "./SecureAdbSlide";
import { IncidentManagementSlide } from "./IncidentManagementSlide";
import { CloudWorkstationsSlide } from "./CloudWorkstationsSlide";
import { InfraAutomationSlide } from "./InfraAutomationSlide";
import { MultiRepoSlide } from "./MultiRepoSlide";
import { BeyondInfotainmentSlide } from "./BeyondInfotainmentSlide";
import { ComplianceGatesSlide } from "./ComplianceGatesSlide";
import { OnboardingKPIsSlide } from "./OnboardingKPIsSlide";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const slideComponents: Record<string, ComponentType<any>> = {
  TitleSlide,
  SectionDividerSlide,
  AgendaSlide,
  TeamSlide,
  ContentSlide,
  FlowSlide,
  ArchitectureSlide,
  ComparisonSlide,
  ImageGridSlide,
  DemoTransitionSlide,
  DiscussionSlide,
  ComingSoonSlide,
  ThankYouSlide,
  GanttSlide,
  VModelSlide,
  TemplatesSnapshotsSlide,
  BehavioralParitySlide,
  HostOSSlide,
  ArmArchitectureSlide,
  POCProposalSlide,
  QuestionsAnsweredSlide,
  SoftwareFactorySlide,
  AuthenticationSlide,
  SecureAdbSlide,
  IncidentManagementSlide,
  CloudWorkstationsSlide,
  InfraAutomationSlide,
  MultiRepoSlide,
  BeyondInfotainmentSlide,
  ComplianceGatesSlide,
  OnboardingKPIsSlide,
};
